import { createForm, createPrimitiveField, type ValidationError } from '@adv-frontend/form-kit';
import { type OpenApiSchemaProduct, type OpenApiSchemaProductVariant } from '../../../api/schema';
import { factoryGetErrorMessage } from '../../../lib/form';

const PRICE_IS_REQUIRED_CODE = 'PRICE_IS_REQUIRED';

type PriceIsRequiredValidationError = ValidationError<typeof PRICE_IS_REQUIRED_CODE>;

export const changeVariantPriceFieldGetErrorMessage = factoryGetErrorMessage<PriceIsRequiredValidationError>({
    [PRICE_IS_REQUIRED_CODE]: 'Укажите цену',
});

const priceField = createPrimitiveField({
    defaultValue: '',
    validators: (createValidators) => createValidators<PriceIsRequiredValidationError>({}),
});

const finalPriceField = createPrimitiveField({
    defaultValue: '',
});

const minimalPriceField = createPrimitiveField({
    defaultValue: '',
});

const promotionPriceField = createPrimitiveField({
    defaultValue: '',
});

const manualDiscountPriceField = createPrimitiveField({
    defaultValue: '',
});

export const changeVariantPriceTooltipForm = createForm({
    name: 'ChangeVariantPriceTooltipForm',
    context: (context: Pick<OpenApiSchemaProductVariant, 'discount' | 'id'>) => {
        return { form: context };
    },
    fields: {
        price: priceField,
        finalPrice: finalPriceField,
        minimalPrice: minimalPriceField,
        promotionPrice: promotionPriceField,
        manualDiscountPrice: manualDiscountPriceField,
    },
    validators: (createValidators) =>
        createValidators<PriceIsRequiredValidationError>({
            onSubmit: [
                (values, formApi) => {
                    if (
                        values.manualDiscountPrice &&
                        Number(values.manualDiscountPrice) !== 0 &&
                        Number(values.price) <= 0
                    ) {
                        formApi.fields.price.addValidationError({ code: PRICE_IS_REQUIRED_CODE });
                    }
                },
            ],
        }),
    onSubmit: (values) => values,
});

export const getProductFormId = (
    productId: OpenApiSchemaProduct['id'],
    variantId?: OpenApiSchemaProductVariant['id']
) => ['change-variant-price-tooltip', productId, variantId].filter(Boolean).join('-');
